<script setup>
import {defineProps, defineEmits} from "vue";
import HeaderDeContasAReceber from "./HeaderDeContasAReceber.vue";
import BodyDeContasAReceber from "./BodyDeContasAReceber.vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

const emits = defineEmits([
    "update:alteraContaAReceber",
]);

//==================================================================//
//==================== Altera Conta a Receber ======================//
//==================================================================//

const alteraContaAReceber = (update)=>{

    emits('update:alteraContaAReceber',update);

};

</script>

<template>

    <v-card>

        <v-card-title class="c-contas-a-receber">

            <h3 class="c-contas-a-receber__titulo">
                Contas a Receber
            </h3>

        </v-card-title>

        <div class="c-table-wrapper">

            <div class="c-table">

                <HeaderDeContasAReceber
                    :dado="props?.dado"
                ></HeaderDeContasAReceber>
                
                <BodyDeContasAReceber
                    :dado="props?.dado"
                    @update:alteraContaAReceber="alteraContaAReceber"
                ></BodyDeContasAReceber>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

/*==================================================================*/
/*============================= Card ===============================*/
/*==================================================================*/

.c-card{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-card__titulo {
    grid-area: titulo;
}

.c-table-wrapper{
    overflow: hidden !important;
    width: calc(100vw - 24px);
    padding: 12px !important;
}

.c-table{
    display: grid;
    grid-template-columns: max-content max-content max-content max-content max-content max-content max-content auto;
    overflow: auto;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
}

</style>